import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import {
  checkEmailValid,
  checkPhoneValid,
} from '../../../../helpers/validation'
import useGetUserProfile from '../../../category/useGetUserProfile'
import { Input } from '../../../html/input'
import { InputTextArea } from '../../../html/input/InputTextArea'
import { PopupAction } from '../../../popup/PopupAction'
import { FORM_FIELD_KEY } from '../constants'
import { postCategoryCheckData } from './thunk'

export const PopupCheckDataAvailability = ({ isOpen, onClose, idReport }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const { userProfile } = useGetUserProfile()
  const [form, setForm] = useState({ customerNote: '', phone: '', email: '' })
  const [isValid, setIsValid] = useState({
    phone: true,
    email: true,
    customerNote: true,
  })

  useEffect(() => {
    setForm({
      [FORM_FIELD_KEY.NAME]: userProfile?.fullName,
      [FORM_FIELD_KEY.EMAIL]: userProfile?.email,
      [FORM_FIELD_KEY.PHONE]: userProfile?.companyPhone,
    })
  }, [userProfile])

  const onSubmit = () => {
    setIsValid({
      phone: checkPhoneValid(form.customerPhone),
      email: checkEmailValid(form.customerEmail),
      customerNote: !!form.customerNote,
    })

    if (
      checkPhoneValid(form.customerPhone) &&
      checkEmailValid(form.customerEmail) &&
      !!form.customerNote
    ) {
      dispatch(
        postCategoryCheckData({
          organizationId,
          fiinGateReportTypeId: idReport,
          fullName: form?.customerName,
          email: form?.customerEmail,
          telephone: form?.customerPhone,
          message: form?.customerNote,
        }),
      )
      onHandleClose()
    }
  }

  const onCancel = () => {
    onHandleClose()
  }

  const onHandleClose = () => {
    onClose()
    setForm({
      [FORM_FIELD_KEY.NAME]: userProfile?.fullName,
      [FORM_FIELD_KEY.EMAIL]: userProfile?.email,
      [FORM_FIELD_KEY.PHONE]: userProfile?.companyPhone,
    })
    setIsValid({ phone: true, email: true })
  }

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (key === FORM_FIELD_KEY.PHONE) {
      let value = ''
      const regex = /^\+?[0-9]*$/g

      if (!eventValue || eventValue.match(regex)) {
        value = eventValue
      }

      if (!eventValue.match(regex)) {
        value = form[FORM_FIELD_KEY.PHONE] || ''
      }

      setIsValid({
        ...isValid,
        phone: checkPhoneValid(value),
      })
      setForm({ ...form, [key]: value })
    } else if (key === FORM_FIELD_KEY.EMAIL) {
      setIsValid({
        email: checkEmailValid(eventValue, true),
      })
      setForm({ ...form, [key]: eventValue })
    } else if (key === FORM_FIELD_KEY.NOTE) {
      setIsValid({
        ...isValid,
        customerNote: true,
      })
      setForm({ ...form, [key]: eventValue.trim() })
    } else {
      setForm({ ...form, [key]: eventValue })
    }
  }

  return (
    <PopupAction
      title="domesticSearchPreview.CHECK_DATA_AVAILABILITY"
      isShow={isOpen}
      handleClose={onClose}
      btnSubmit={{
        label: 'domesticSearchPreview.SUBMIT',
        event: onSubmit,
        isI18n: true,
      }}
      btnCancel={{
        label: 'domesticSearchPreview.CANCEL',
        event: onCancel,
        isI18n: true,
      }}
    >
      <div className="pt1 flexColumn" style={{ gap: 29 }}>
        <Input
          disabled
          isShowLabel
          isShowIcon={false}
          placeHolder="domesticSearchPreview.FULL_NAME"
          value={form[FORM_FIELD_KEY.NAME]}
        />
        <Input
          disabled
          isShowLabel
          isShowIcon={false}
          isValid={isValid.email}
          placeHolder="domesticSearchPreview.EMAIL"
          value={form[FORM_FIELD_KEY.EMAIL] || ''}
          textInvalid={
            typeof form.customerEmail === 'string' &&
            !!form.customerEmail.trim()
              ? 'domesticSearchPreview.INVALID_EMAIL'
              : 'domesticSearchPreview.REQUIRED_FIELD'
          }
        />
        <Input
          disabled
          isShowLabel
          isShowIcon={false}
          isValid={isValid.phone}
          placeHolder="domesticSearchPreview.PHONE_NUMBER"
          value={form[FORM_FIELD_KEY.PHONE] || ''}
          textInvalid={
            typeof form.customerPhone === 'string' &&
            !!form.customerPhone.trim()
              ? 'domesticSearchPreview.INVALID_PHONE'
              : 'domesticSearchPreview.REQUIRED_FIELD'
          }
        />
        <InputTextArea
          isShowLabel
          placeHolder="domesticSearchPreview.LEAVE_US_A_MESSAGE"
          isValid={isValid.customerNote}
          rows={8}
          onChange={(e) => onChange(FORM_FIELD_KEY.NOTE, e)}
          textInvalid={'domesticSearchPreview.REQUIRED_FIELD'}
        />
      </div>
    </PopupAction>
  )
}
